export enum ProFormaTranslationPaths {
  Title = 'proformaTemplate.title',
  Date = 'proformaTemplate.date',
  Dates = 'proformaTemplate.dates',
  RefNumber = 'proformaTemplate.refNumber',
  AccNumber = 'proformaTemplate.accNumber',
  PurchaseOrderNum = 'proformaTemplate.purchaseOrderNumber',
  Total = 'proformaTemplate.total',
  TotalDue = 'proformaTemplate.totalDue',
  SubTotal = 'proformaTemplate.subTotal',
  Hotel = 'proformaTemplate.hotel',
  NumberOfRooms = 'proformaTemplate.numberOfRooms',
  RoomNights = 'proformaTemplate.roomNights',
  Passengers = 'proformaTemplate.passengers',
  None = 'proformaTemplate.none',
  Net = 'proformaTemplate.net',
  Vat = 'proformaTemplate.vat',
}
